import { useOfficeComponentContext } from '@office-start/component-context-service';
import { useSharedContext } from '@office-start/context-service';
import { queryCache, useQuery } from '@office-start/data-fetching';
import { useIdentity } from '@office-start/identity-service';
import { executeMyDriveInfoDataFlow } from '../data-flows/executeMyDriveInfoDataFlow';
export function useMyDriveInfo() {
    var componentContext = useOfficeComponentContext().data;
    var identity = useIdentity().data;
    var sharedContext = useSharedContext().data;
    var query = ['GraphMyDriveInfo'];
    return useQuery(query, function () {
        return executeMyDriveInfoDataFlow(
        // Query is only enabled when all of these are defined.
        /* eslint-disable @typescript-eslint/no-non-null-assertion */
        componentContext, identity, sharedContext, 
        /* eslint-enable @typescript-eslint/no-non-null-assertion */
        function (freshData) {
            return queryCache.setQueryData(query, freshData);
        });
    }, {
        staleTime: Infinity,
        cacheTime: Infinity,
        enabled: componentContext && identity && sharedContext,
    });
}
//# sourceMappingURL=useMyDriveInfo.js.map